import React from 'react';
import { FolderInput, Brain, Home, Upload } from 'lucide-react';

const STEPS = [
  {
    icon: FolderInput,
    title: 'Drop the closing folder',
    body:
      'Point Sortio at your Downloads, Desktop, or transaction-coordinator intake folder: signed contracts, MLS exports, drone photos, inspection PDFs, settlement statements, commission disclosures, all the loose ends from a deal.',
  },
  {
    icon: Brain,
    title: 'Read content, extract property',
    body:
      'Sortio identifies the property address, transaction parties (buyer, seller, listing and selling agents, lender, title company), document type, and date on each file. PDFs are parsed for text; photos are matched via EXIF metadata and visible address signage when present.',
  },
  {
    icon: Home,
    title: 'Route per-property',
    body:
      'Each file lands in the right property folder (for example, 1127 S Cornell Terrace) with role-based subfolders: Contracts, Disclosures, Photos, Inspection, Closing, Commission. Mixed listings sort cleanly in one pass.',
  },
  {
    icon: Upload,
    title: 'Rename and archive',
    body:
      'DSC_0001.JPG becomes 1127 S Cornell Terrace - Kitchen - 01.jpg. ALTA-Combined.pdf becomes ALTA Settlement Statement - 1127 S Cornell Terrace - 2026-04-12.pdf. Closed deals archive into a per-year retention folder with a clean structure your broker auditor will recognize.',
  },
];

const Workflow = () => {
  return (
    <section id="workflow" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          How transaction filing works
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Four steps from a Desktop full of closing files to clean per-property folders.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((step, i) => {
          const Icon = step.icon;
          return (
            <div key={i} className="relative bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 flex flex-col">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-3">
                  <Icon className="text-sortio-primary" size={18} />
                </div>
                <span className="text-xs font-medium uppercase tracking-wider text-apple-400">Step {i + 1}</span>
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-2">{step.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{step.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workflow;
